import React, {useState} from 'react';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './AddressLookupComponent.metadata.json5';
import messages from './AddressLookupComponent.messages';
import styles from './AddressLookupComponent.module.scss';

function AddressLookupComponent(props) {
    const { model, onValueChange, hideFields = [], readOnlyFields = [] } = props;
    const fields = [
        'override', 
        'addressLine1', 
        'addressLine2', 
        'addressLine3',
        'city',
        'state',
        'country',
        'postalCode',
        'addressType'
     ]
     const [overrideAddress, setOverrideAddress] = useState(false);

    const generateOverrides = () => {
        const overrides = fields.map((field) => {
            return {
                [`addressLookup${field}`]: {
                    visible: hideFields.indexOf(field) == -1,
                    readOnly: readOnlyFields.indexOf(field) != -1
                }
            };
        });
        return Object.assign({}, ...overrides);
    }

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            onValueChange: onValueChange,
            showRequired: true
        },        
        addressLookUpoverride:{
            value: overrideAddress,
            onValueChange: () => { setOverrideAddress(!overrideAddress) }
        },
        ...generateOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {},
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={model}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

export default AddressLookupComponent
